export default __webpack_public_path__ + "static/media/plaque1Edited.70ce826f.png";